import { useEffect, useState } from "react";
import Style from "./style.module.css";
import InnerLoader from "../../../../component/ui/loader/inner-loader";
import DataNotFound from "../../../../component/ui/loader/data-not-found";
import { useApiCall } from "../../../../component/custom-hooks/api-call";
import DynamicFilter from "../../../../component/table/filter-table/dynamic-filter";
import FilterFunnel01Icon from "../../../../component/icons/filter-funnel-01";
import { Table, TableBody, TableCard, TableCell, TableDepartmentTag, TableFilterReturn, TableFooter, TableHead, TableHeaderWrap, TableRow, } from "../../../../component/table/table-layout";
import CustomizeTabsPopup from "../../../../component/table/customize-table";
import Tooltip from "../../../../component/ui/tooltip";
import LayoutTopIcon from "../../../../component/icons/layout-top";
import moment from "moment";
import StatusChip from "../../../../component/ui/chip/status";
import AvatarProfile from "../../../../component/ui/profile";
import { TitleHeading } from "../../../../component/ui/layout";
import { Clicks, Conversions, Cpa, Cpc, Ctr, DateRange, Impressions, OperationName, Revenue, Roas, TotalUpsell } from "../../../../component/icons/filter-icon";

const ServiceList = () => {
  const apiCall = useApiCall();
  const [isLoading, setIsLoading] = useState(true);
  const [lists, setList] = useState([]);
  const [showModalFilterTable, setShowModalFilterTable] = useState(false);
  const [filterReturn, setFilterReturn] = useState([]);
  const [saveFilter, setSaveFilter] = useState([]);
  const [tableHeaders, setTableHeaders] = useState([]);
  const [showModalCustomizeTabs, setShowModalCustomizeTabs] = useState(false);
  const [footer, setFooter] = useState({})

  useEffect(() => {
    getData({});
  }, []);

  const getData = async ({ filter = filterReturn, page = "" }) => {
    if (!page) {
      setIsLoading(true);
    }
    let extraUrl = `?page=${page}`;
    for (let i = 0; i < filter?.length; i++) {
      if (filter[i]?.selectedOpt == "between") {
        extraUrl += `&${filter[i]?.name}=${filter[i]?.value[0]}_${filter[i]?.value[1]}`;
      } else {
        extraUrl += `&${filter[i]?.name}=${filter[i]?.value}`;
      }
    }
    try {
      const res = await apiCall({
        method: "get",
        url: `get-service-performance-analysis${extraUrl}`,
      });
      setList(res.data);
      setTableHeaders(res.headers);
      setSaveFilter(res?.custom_filters);
      setFooter(res?.footer)
      setIsLoading(false);
    } catch (error) {
      console.warn("Error : ", error);
    }
  };

  const filterModalData = [
    {
      name: "service",
      label: "Service",
      options: ["contains"],
      selectedOpt: "contains",
      value: "",
      type: "text",
      Icon: OperationName
    },
    {
      name: "date_range",
      label: "Date Range",
      options: ["between"],
      selectedOpt: "between",
      value: "",
      type: "date",
      betweenType: "date",
      Icon: DateRange
    },
    {
      name: "clicks",
      label: "Number Of Clicks",
      options: ["between"],
      selectedOpt: "between",
      value: "",
      type: "number",
      betweenType: "number",
      Icon: Clicks
    },
    {
      name: "impressions",
      label: "Number Of Impressions",
      options: ["between"],
      selectedOpt: "between",
      value: "",
      type: "number",
      betweenType: "number",
      Icon: Impressions
    },
    {
      name: "ad_spend",
      label: "Ad Spend",
      options: ["between"],
      selectedOpt: "between",
      value: "",
      type: "number",
      betweenType: "number",
      Icon: Roas
    },
    {
      name: "conversions",
      label: "Conversions",
      options: ["between"],
      selectedOpt: "between",
      value: "",
      type: "number",
      betweenType: "number",
      Icon: Conversions
    },
    {
      name: "revenue",
      label: "Revenue",
      options: ["between"],
      selectedOpt: "between",
      value: "",
      type: "number",
      betweenType: "number",
      Icon: Revenue
    },
    {
      name: "ctr",
      label: "CTR",
      options: ["between"],
      selectedOpt: "between",
      value: "",
      type: "number",
      betweenType: "number",
      Icon: Ctr
    },
    {
      name: "cpc",
      label: "CPC",
      options: ["between"],
      selectedOpt: "between",
      value: "",
      type: "number",
      betweenType: "number",
      Icon: Cpc
    },
    {
      name: "roas",
      label: "ROAS",
      options: ["between"],
      selectedOpt: "between",
      value: "",
      type: "number",
      betweenType: "number",
      Icon: Roas
    },
    {
      name: "cpa",
      label: "CPA",
      options: ["between"],
      selectedOpt: "between",
      value: "",
      type: "number",
      betweenType: "number",
      Icon: Cpa
    }
  ];

  return (
    <>
      <div className={Style.leaveMainPage}>
        <TableFilterReturn
          filterReturn={filterReturn}
          onChange={(filters) => {
            setFilterReturn(filters);
            getData({ filter: filters });
          }}
        />
        <div className={Style.report_table__header}>
          <TitleHeading title={'PPC Services'} />

          <div className={Style.bpfl_action}>
            <Tooltip
              className={Style.bpfl_actionItems}
              content={"Table Filter"}
              position={"left center"}
            >
              <div
                className={`${Style.bpfl_actionBtn} ${filterReturn?.length ? Style.active : null
                  }`}
                onClick={() => {
                  setShowModalFilterTable(true);
                }}
              >
                <div className={Style.icon}>
                  <FilterFunnel01Icon />
                </div>
              </div>
            </Tooltip>
            <div className={`${Style.bpfl_action}`}>
              <Tooltip
                className={`${Style.bpfl_actionItems}`}
                content={"Customize Table"}
                position={"left center"}
              >
                <div
                  className={`${Style.bpfl_actionBtn}`}
                  onClick={() => {
                    setShowModalCustomizeTabs(true);
                  }}
                >
                  <div className={Style.icon}>
                    <LayoutTopIcon />
                  </div>
                </div>
              </Tooltip>
            </div>
          </div>
        </div>

        <div className={Style.LeaveBody}>
          {isLoading ? (
            <InnerLoader />
          ) : !lists?.length ? (
            <div className="w-full h-full flex items-center justify-center">
              <DataNotFound title={"Lists"} />
            </div>
          ) : (
            <>
              <TableCard>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell header sticky><TableHeaderWrap> <span className="w-[28px]"></span> Service Name</TableHeaderWrap></TableCell>
                      {tableHeaders?.map((eachHead, index) =>
                        eachHead.is_visible === 1 && eachHead?.show == 1 ? (
                          <TableCell header key={index}>
                            <TableHeaderWrap>
                              <span>{eachHead?.value}</span>
                            </TableHeaderWrap>
                          </TableCell>
                        ) : null
                      )}
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {lists?.map((eachList, index) => {
                      return (
                        <TableRow key={`cars_${index}`}>
                          <TableCell sticky>
                            {/* <AvatarProfile src={eachList?.profile_picture} title={eachList?.assigned_user} /> */}
                            <div className="flex items-center gap-[10px]">
                              <span className="w-[28px]">{index + 1}</span>
                              <div className="font-medium leading-5">{eachList?.service}</div>
                            </div>
                          </TableCell>

                          {tableHeaders?.map((eachHead, i) =>
                            eachHead.is_visible === 1 && eachHead?.show == 1 ? (
                              <>
                                {eachHead.key === "status" ? (
                                  <TableCell
                                    key={`${i}-${index}`}
                                    className={`text-center`}
                                  >
                                    {eachList[eachHead?.key] === "Active" ?
                                      <StatusChip color="green">{eachList[eachHead?.key] || "--"}</StatusChip>
                                      :
                                      <StatusChip color="red">{eachList[eachHead?.key] || "--"}</StatusChip>}
                                  </TableCell>
                                ) : eachHead.key === "assigned_user_department" ? (
                                  <TableCell
                                    key={`${i}-${index}`}
                                    className={`text-center`}
                                  >
                                    <TableDepartmentTag title={eachList[eachHead?.key]} />
                                  </TableCell>
                                ) : (
                                  <TableCell key={`${i}-${index}`}>
                                    {(eachHead?.key == "profit_loss" || eachHead?.key == "fresh_roi" || eachHead?.key == "total_roi") ?
                                      <span className={eachList[eachHead?.key]?.includes("-") ? "text-red-500" : (eachList[eachHead?.key] == "$0.00" || eachList[eachHead?.key] == "0.00%") ? "" : "text-green-500"}>{eachList[eachHead?.key]}</span>
                                      :
                                      eachList[eachHead?.key] ?? "-"
                                    }
                                  </TableCell>
                                )
                                }
                              </>
                            ) : null
                          )}
                        </TableRow>
                      );
                    })}
                  </TableBody>

                  <TableFooter>
                    <TableRow>
                      <TableCell header sticky className="!font-bold !bg-[#f6f7f7]"></TableCell>
                      {tableHeaders?.map((head, hIdx) => {
                        return (
                          head.is_visible === 1 && head.show == 1 ? (
                            <TableCell header key={`footer_cell_${hIdx}`} className="!font-bold !bg-[#f6f7f7]">
                              {head.key === "status" ? (
                                <StatusChip color={footer[head.key] === "Active" ? "green" : "red"}>
                                  {footer[head.key] || "--"}
                                </StatusChip>
                              ) : head.key === "assigned_user_department" ? (
                                <TableDepartmentTag title={footer[head.key]} />
                              ) : (head.key == "profit_loss" || head.key == "fresh_roi" || head.key == "total_roi") ? (
                                <span
                                  className={
                                    footer[head.key]?.includes("-") ? "text-red-500" : (footer[head.key] == "$0.00" || footer[head.key] == "0.00%") ? "" : "text-green-500"
                                  }
                                >
                                  {footer[head.key]}
                                </span>
                              ) : (
                                footer[head.key] ?? "-"
                              )}
                            </TableCell>
                          ) : null
                        )
                      }

                      )}
                    </TableRow>
                  </TableFooter>
                </Table>
              </TableCard>
            </>
          )}
        </div>
      </div>

      {showModalFilterTable && (
        <DynamicFilter
          data={filterModalData}
          onClose={() => setShowModalFilterTable(false)}
          returnData={filterReturn}
          onSave={(filters) => {
            getData({ filter: filters });
            setShowModalFilterTable(false);
            setFilterReturn(filters);
          }}
          saveFilter={saveFilter}
          apiUrl="get-service-performance-analysis"
        />
      )}

      {showModalCustomizeTabs && (
        <CustomizeTabsPopup
          data={tableHeaders}
          onClose={() => {
            setShowModalCustomizeTabs(false);
          }}
          onPreview={(updatedHeaders) => {
            setTableHeaders(updatedHeaders);
          }}
          onSave={(saveHeaders) => {
            setTableHeaders(saveHeaders);
          }}
          apiUrl="get-service-performance-analysis"
        />
      )}
    </>
  );
};

export default ServiceList;
